function UsersListRow({userlist}: any) {
  return (
    <tr>
      <td>{userlist.Id}</td>
      <td>{userlist.Email ? userlist.Email : '-'}</td>
      <td>{userlist.DcsSiteId ? userlist.DcsSiteId : '-'}</td>
      <td>{userlist.DcsUserId ? userlist.DcsUserId : '-'}</td>
      <td>{userlist.AvatarUrl ? userlist.AvatarUrl : '-'}</td>
      <td>{userlist.DisplayName ? userlist.DisplayName : '-'}</td>
      <td>{userlist.CustomerId ? userlist.CustomerId : '-'}</td>
      <td>{userlist.Company ? userlist.Company : '-'}</td>
      <td>{userlist.Role ? userlist.Role : '-'}</td>
      <td>{userlist.Status ? userlist.Status.toString() : '-'}</td>
      <td>{userlist.Action ? userlist.Action : '-'}</td>
    </tr>
  )
}

export default UsersListRow
